import { render, staticRenderFns } from "./ByAlphabet.vue?vue&type=template&id=58bdf505&"
import script from "./ByAlphabet.vue?vue&type=script&lang=js&"
export * from "./ByAlphabet.vue?vue&type=script&lang=js&"
import style0 from "./ByAlphabet.vue?vue&type=style&index=0&id=58bdf505&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports